$(document).ready(function () {
  console.log('hfcjs');
  if ( $('#featuredItems').length ) {
    $('#featuredItems').flickity({
      // options
      cellAlign: 'left',
      cellSelector: '.featured-slide',
      pageDots: false,
      contain: true
    });
  }
  
  if ( $('.products-grid').length ) {
    var $grid = $('.products-grid').isotope({
      // options
      layoutMode: 'fitRows'
    });
    // filter items on button click
    $('.filter-button-group').on( 'click', 'button', function() {
      var filterValue = $(this).attr('data-filter');
      console.log(filterValue);
      $grid.isotope({ filter: filterValue });
    });
  }

});
$('.accordion-opener').on('click', function () {
  console.log($(this));
  var thisParent = $(this).closest('.accordion-wrapper');
  var thisContent = thisParent.find('.accordion-content');
  var thisSpan = $(this).find('span');
  if ($(this).hasClass('opened')) {
    thisContent.slideUp();
    thisSpan.text("+");
    $(this).removeClass('opened');
  } else {
    thisContent.slideDown();
    thisSpan.text("-");
    $(this).addClass('opened');
  }
});
$('.sub-link-opener').on('click', function () {
  console.log($(this));
  var thisParent = $(this).closest('.sub-link');
  var thisTarget = thisParent.next();
  var allOpeners = thisParent.find('.sub-link-opener');
  var openerSpan = allOpeners.find('span');
  if (thisParent.hasClass('opened')) {
    thisTarget.slideUp();
    thisParent.removeClass('opened');
    openerSpan.html('+');
  } else {
    thisTarget.slideDown();
    thisParent.addClass('opened');
    openerSpan.html('-');
  }

});